import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { EventManager } from 'src/app/core';

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss']
})
export class PagingComponent implements OnInit, OnChanges {
  @Input() total: any;
  @Input() size: any;
  @Input() selectedPage: number;
  @Output() loadPage: EventEmitter<any> = new EventEmitter();
  @Output() loadPageSize: EventEmitter<any> = new EventEmitter();
  totalPage: number;
  start: number;
  end: number;
  pages: number[] = [];
  sizes: any[]  = [{size: 5, name: '5'},{size: 10, name: '10'},{size: 20, name: '20'},{size: 50, name: '50'}, {size: 100, name: '100'}];
  constructor(
    public eventManager: EventManager,
  ) {}
  loadPageEvent(event) { 
    this.loadPage.emit(event);
  }
  loadPageSizeEvent(event) { 
    this.selectedPage = 1;
    this.loadPageSize.emit(event);
    this.eventManager.broadcast({
      name: 'load-page-size',
      content: {
        size: event
      }
    });
  }
  ngOnInit() {
  }
  setUp() {
    this.totalPage = Math.ceil((this.total || 0)/ this.size) || 1;
    this.pages = [];
    this.selectedPage = this.selectedPage || 1;
    this.start = (this.selectedPage - 1) * this.size + 1;
    this.end = this.selectedPage * this.size;
    this.end = this.end > this.total ? this.total : this.end;
    for (let i = 0; i < this.totalPage; i++) {
      this.pages.push(i + 1);
    }
    this.setPages();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.setUp();
  }
  setPages() {
    this.pages = [this.selectedPage];
    let before = 2, valueBefore = 1, after = 2, valueAfter = 1;

    for (let i = 0 ; i < 5; i++) {
        if (before > 0) {
            if (this.selectedPage - valueBefore > 0) {
                before--;
                this.pages.unshift(this.selectedPage - valueBefore)
                valueBefore++;
            } else {
                after+= before;
                before = 0;
            }
        }
        if (after > 0){
            if (this.selectedPage + valueAfter <= this.totalPage) {
                after--;
                this.pages.push(this.selectedPage + valueAfter)
                valueAfter++;
            } else {
                before+= after;
                after = 0;
            }
        }
    }
  }
  changePage(page) {
    this.selectedPage = page;
    if (this.selectedPage < 1) {
      this.selectedPage = 1;
    }
    if (this.selectedPage > this.totalPage) {
      this.selectedPage = this.totalPage;
    }
    this.loadPage.emit(this.selectedPage);
    this.eventManager.broadcast({
      name: 'load-page',
      content: {
        page: this.selectedPage
      }
    });
    this.setUp();
  }
  next() {
    this.changePage(this.selectedPage + 1);
  }
  previous() {
    this.changePage(this.selectedPage - 1);
  }
  checkPrevious() {
    return this.selectedPage > 1  ? true : false;
  }
  checkNext() {
    return this.selectedPage < this.totalPage ? true : false;
  }
  checkFirst() {
    return this.selectedPage !== 1  ? true : false;
  }
  checkLast() {
    return this.selectedPage !== this.totalPage  ? true : false;
  }
  first() {
    if (this.totalPage > 4) {
        this.setPages();
    } else {
        this.pages = [];
        for (let i = 0 ; i < this.totalPage; i++) {
            this.pages.push(i+1);
        }
    }
    this.changePage(1);
  }
  last() {
    this.changePage(this.totalPage);
  }
}
